module.exports = __webpack_public_path__ + "img/rocket.a2d15a90.svg";